import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import TimeAgo from './TimeAgo';
import LikeComment from './LikeComment';
import Comments from './Comments';
import secureLocalStorage from 'react-secure-storage';
import renderHTML from "./RenderHtml";
import UserAvatar from './UserAvatar';

const AudioPlayer = ({ src, title, onLoad }) => {
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);

    const fmt = (s) => `${Math.floor(s / 60)}:${Math.floor(s % 60).toString().padStart(2, '0')}`;

    const togglePlay = () => {
        if (isPlaying) { audioRef.current.pause(); } else { audioRef.current.play(); }
        setIsPlaying(!isPlaying);
    };

    const handleEnded = () => { setIsPlaying(false); setCurrentTime(0); };

    return (
        <div className="custom-audio-player">
            <audio
                ref={audioRef}
                src={src}
                onTimeUpdate={() => setCurrentTime(audioRef.current.currentTime)}
                onLoadedData={() => { setDuration(audioRef.current.duration); onLoad && onLoad(); }}
                onEnded={handleEnded}
            />
            <div className="audio-icon-wrap">
                <i className="fas fa-music"></i>
            </div>
            <div className="audio-body">
                <div className="audio-title">{title || 'Audio'}</div>
                <div className="audio-controls">
                    <button className="audio-play-btn" onClick={togglePlay}>
                        <i className={`fas ${isPlaying ? 'fa-pause' : 'fa-play'}`}></i>
                    </button>
                    <input
                        type="range"
                        className="audio-progress"
                        min="0"
                        max={duration || 0}
                        value={currentTime}
                        step="0.1"
                        onChange={(e) => { audioRef.current.currentTime = e.target.value; setCurrentTime(e.target.value); }}
                    />
                    <span className="audio-time">{fmt(currentTime)} / {fmt(duration)}</span>
                </div>
            </div>
        </div>
    );
};
const formatDateTime = (date) =>
    new Date(date).toLocaleString(undefined, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    });

const PRIVACY_META = {
    0: { icon: 'fa-globe',       label: 'Public'       },
    1: { icon: 'fa-lock',        label: 'Only Me'      },
    2: { icon: 'fa-user-friends', label: 'Friends Only' },
};

const PostBox1 = ({ post, usrAuth, setSinlgePost, inGroup, groupAdmins }) => {
    const [loading, setLoading] = useState(true);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [privacy, setPrivacy] = useState(post.post_data.privacy ?? 0);
    const [postDate, setPostDate] = useState(post.post_data.created_at);
    const [isDateEdited, setIsDateEdited] = useState(post.post_data.is_date_edited === true);
    const [taggedUsers, setTaggedUsers] = useState(post.tagged_users || []);
    const didInitialLoad = useRef(false);

    const navigate = useNavigate();

    const auth = JSON.parse(secureLocalStorage.getItem('auth_data'));

    const handleRemoveTag = async (userId) => {
        try {
            const res = await axios.post('https://buzzinguniverse.com/backend/api/remove-tag', {
                post_id: post.post_data.id,
                user_id: userId,
            });
            if (res.data.code === 200) {
                setTaggedUsers(prev => prev.filter(u => u.id !== userId));
                setShowPopup(false);
            }
        } catch (error) {
            console.error('Remove tag failed:', error);
        }
    };

    const chekStrg = (strg) => {
        if (strg == "https://buzzinguniverse.com/backend/") {
            return null;
        } else {
            return strg
        }
    }

    useEffect(() => {
        if (didInitialLoad.current) return;
        didInitialLoad.current = true;
        if (post) {
            setTimeout(() => setLoading(false), 2000);
        }
    }, [post]);

    useEffect(() => {
        document.querySelectorAll('[nav_id]').forEach((men) => {
            men.addEventListener('click', function () {
                const type = men.getAttribute('mention_type');
                const id = men.getAttribute('nav_id');
                if (type === 'group' || type === 'company') {
                    const name = men.getAttribute('nav_name') || 'page';
                    navigate(`/company/${id}/${name}`);
                } else {
                    navigate(`/member/${id}/profile`);
                }
            })
        })
    })

    const handleImageLoad = () => {
        setImageLoaded(true);
    };

    if (loading) {
        return (
            <div className="skeleton">
                <div className="header">
                    <div className="profile-pic"></div>
                    <div>
                        <div className="text"></div>
                        <div className="timestamp"></div>
                    </div>
                </div>
                <div className="image"></div>
            </div>
        );
    }

    const group = post.group_data || null;

    const isAdmin = inGroup && group && (
        group.user_id == post.post_data.user.id ||
        groupAdmins?.some(a => a.user?.id == post.post_data.user.id)
    );

    return (
        <div className="personal_des_box activity-all-memeber-boxs">
            <ul className='personal_des_list'>
                <li data-user-online={auth?.id == post.post_data.user.id}>
                    {isAdmin ? (
                        <Link to={`/company/${group.id}/${encodeURIComponent(group.name)}`}>
                            <img
                                src={chekStrg(group.profile_picture) ? `https://buzzinguniverse.com/backend/${group.profile_picture}` : '/images/default.png'}
                                alt="img"
                            />
                        </Link>
                    ) : (
                        <Link to={`/member/${post.post_data.user.id}/profile`}>
                            <UserAvatar
                                src={chekStrg(post.post_data.user?.photo) ? `https://buzzinguniverse.com/backend/${post.post_data.user.photo}` : '/images/default.png'}
                                alt="img"
                            />
                        </Link>
                    )}
                </li>
                <li>
                    {isAdmin ? (
                        <Link to={`/company/${group.id}/${encodeURIComponent(group.name)}`}>{group.name}</Link>
                    ) : (
                        <Link to={`/member/${post.post_data.user.id}/profile`}>{post.post_data.user.first_name} {post.post_data.user.last_name}</Link>
                    )}
                    {taggedUsers.length > 0 ? (
                        <div className="tf-tagged-users">
                            is with
                            {taggedUsers.slice(0, 2).map((u, index) => (
                                <span key={u.id} className="tf-tag-item ms-1">
                                    <Link to={`/member/${u.id}/profile`} className="tf-tag-badge">
                                        {u.first_name} {u.last_name}
                                    </Link>
                                    {index < Math.min(1, taggedUsers.length - 1) && ','}
                                </span>
                            ))}
                            {taggedUsers.length > 2 && (
                                <span className="tf-tag-badge ms-1 cursor-pointer" onClick={() => setShowPopup(true)}>
                                    and {taggedUsers.length - 2} others
                                </span>
                            )}
                        </div>
                    ) : (!inGroup && <p>{post.post_data.title}</p>)}

                </li>
                {group && !inGroup && <li>
                    <Link className='groupNbgh'>
                        in
                        <img
                            src={chekStrg(group.profile_picture) ? `https://buzzinguniverse.com/backend/${group.profile_picture}` : '/images/default.png'}
                            alt="img"
                        />
                        {group.name}
                    </Link>
                </li>}
                <li>
                    <strong>{formatDateTime(postDate)}</strong>
                    {isDateEdited && <span className="post-edited-badge">edited</span>}
                    <span className="post-privacy-badge">
                        <i className={`fas ${PRIVACY_META[privacy]?.icon}`}></i>
                        {PRIVACY_META[privacy]?.label}
                    </span>
                </li>
            </ul>
            {post.post_data.type == 3 ? (() => {
                const usrt = JSON.parse(post.post_data.profile_data);
                return usrt && <div className="search-groups-boxs">
                    <div className="search-groups-box-back" style={{ backgroundImage: `url(${chekStrg(usrt.cover_photo) ? `https://buzzinguniverse.com/backend/${usrt.cover_photo}` : ''})` }} />
                    <ul className="profile_upd">
                        <li>
                            <span><UserAvatar src={chekStrg(usrt.photo) ? `https://buzzinguniverse.com/backend/${usrt.photo}` : '/images/default.png'} alt="img" /></span>
                        </li>
                        <li>
                            <h5><Link to={`/member/${usrt.id}/profile`}>{usrt.first_name} {usrt.last_name}</Link></h5>
                        </li>
                    </ul>
                </div>
            })()
                : <>{post.post_data.details != 'null' && <p>{renderHTML(post.post_data.details)}</p>}
                    <div onClick={() => setSinlgePost(post)} style={{ cursor: 'pointer' }}>
                        {post.post_data.file_type === 'jpg' || post.post_data.file_type === 'png' || post.post_data.file_type === 'gif' ? (
                            <div className="image-container">
                                {!imageLoaded && <div className="skeleton">
                                    <div className="image"></div>
                                </div>}
                                <img
                                    src={`https://buzzinguniverse.com/backend/${post.post_data.file}`}
                                    alt="img"
                                    className="personal_des_box_image"
                                    onLoad={handleImageLoad}
                                    style={{ display: imageLoaded ? 'block' : 'none' }}
                                />
                            </div>
                        ) : null}
                        {post.post_data.file_type === 'mp4' || post.post_data.file_type === 'mov' || post.post_data.file_type === 'webm' ? (
                            <div className="image-container">
                                {!imageLoaded && <div className="skeleton">
                                    <div className="image"></div>
                                </div>}
                                <video
                                    src={`https://buzzinguniverse.com/backend/${post.post_data.file}`}
                                    className="personal_des_box_image"
                                    onLoadedData={handleImageLoad}
                                    style={{ display: imageLoaded ? 'block' : 'none' }}
                                    controls
                                ></video>
                            </div>
                        ) : null}
                        {post.post_data.file_type === 'mp3' || post.post_data.file_type === 'wav' || post.post_data.file_type === 'ogg' ? (
                            <AudioPlayer
                                src={`https://buzzinguniverse.com/backend/${post.post_data.file}`}
                                title={post.post_data.file?.split('/').pop().replace(/\.[^.]+$/, '').replace(/^\d+_/, '').replace(/[-_]/g, ' ')}
                                onLoad={handleImageLoad}
                            />
                        ) : null}</div></>
            }
            {auth && <LikeComment post={post} onPrivacyChange={setPrivacy} onDateChange={(id, newDate) => { setPostDate(newDate); setIsDateEdited(true); }} isTagged={taggedUsers.some(u => u.id === auth?.id)} onRemoveTag={() => handleRemoveTag(auth?.id)} />}
            <div className='commentScroll1'>
                <Comments post={post} auth={auth} loadmore={true} />
            </div>
            {showPopup && (
                <div className="tf-popup-overlay" onClick={() => setShowPopup(false)}>
                    <div className="tf-popup" onClick={(e) => e.stopPropagation()}>
                        <h3 className="tf-title">Tagged Friends</h3>
                        <ul className="tf-user-list">
                            {taggedUsers.map((user) => {
                                return (
                                    <li key={user.id} className={`tf-user-item`}>
                                        <Link to={`/member/${user.id}/profile`} onClick={() => setShowPopup(false)} style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit', flex: 1 }}>
                                            <UserAvatar src={(user.photo && "https://buzzinguniverse.com/backend/" + user.photo) || "/images/default.png"} alt="profile" className='me-2' />
                                            <span>{user.first_name} {user.last_name}</span>
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                        <button className="tf-done-btn bg-danger" onClick={() => setShowPopup(false)}>
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PostBox1;
